module.exports = __webpack_public_path__ + "static/media/historical.5899084e.jpg";